/** Types of colors available */
export type ColorType = 'primary' | 'secondary' | 'tertiary' | 'light' | 'medium' | 'dark' | 'success' | 'warning' | 'danger';
/** All color types with their respective color steps */
export type IColorTypes = Record<ColorType, IColorSteps>;
/** All available color types */
export const COLOR_TYPES: ColorType[] = ['primary', 'secondary', 'tertiary', 'light', 'medium', 'dark', 'success', 'warning', 'danger'];

/** Types of color steps available */
export type ColorStep = 'main' | 'shade' | 'shine' | 'contrast';
/** All color steps with their respective color value */
export type IColorSteps = Record<ColorStep, string>;
/** All available color steps */
export const COLOR_STEPS: ColorStep[] = ['shine', 'main', 'shade', 'contrast'];
